import { desktopCapturer } from "electron";
import { MainProcessBusEvent } from "../types/types";

export type ScreenCaptureSource = Electron.DesktopCapturerSource & {
	thumbnail: string;
};

/**
 * Provides desktopCapturer.getSources() to renderer process via fin.System
 *
 * Previously, the desktopCapturer.getSources() API was available in the the renderer process,
 * but this was deprecated in Electron 17+
 */
export class ScreenCapture {
	public static async getScreenShareSources(eventObj: MainProcessBusEvent) {
		const options = eventObj.data;

		const sources = (await desktopCapturer.getSources(options)).map((source) => {
			return {
				...source,
				thumbnail: source.thumbnail.toDataURL(),
			};
		});

		try {
			eventObj.respond({
				status: "success",
				message: "desktopCapturer sources retrieved successfully",
				value: sources,
			});
		} catch (err) {
			eventObj.respond({
				status: "error",
				message: `Error getting sources from desktopCapturer: ${err}`,
			});
		}
	}
}
